module.exports = __webpack_public_path__ + "static/media/get-started-title.3eb79957.png";